import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import SettingsSection from 'components/settings/SettingsSection'

import RadioList from 'components/settings/RadioList'
import Range from 'components/settings/Range'
import BigButton from 'components/settings/BigButton'
import Link from 'components/common/Link'

class Settings extends React.PureComponent {
  static propTypes = {
    initialValues: PropTypes.object,
    onChanged: PropTypes.func,
    onDelete: PropTypes.func
  }
  static defaultProps = {
    initialValues: {},
    onChanged: () => {},
    onDelete: () => {}
  }

  constructor(props) {
    super(props)
    const { initialValues } = props

    this.state = {
      showMe: initialValues.showMe || 'male',
      distanceIn: initialValues.distanceIn || 'miles',
      ageRange: initialValues.ageRange || [18, 26],
      maxDistance: initialValues.maxDistance || 50,
      isInteracting: false
    }
  }

  sendData = () => {
    const { isInteracting, ...data } = this.state
    if (isInteracting) return

    this.props.onChanged(data)
  }

  getDistanceString = distance => {
    const unit = this.state.distanceIn === 'miles' ? 'Miles' : 'Kilometer'
    return `${distance} ${unit}`
  }

  handleRangeStart = () => {
    this.setState({ isInteracting: true })
  }

  handleChange = event => {
    const { name, value } = event.target
    this.setState({ [name]: value }, () => {
      this.sendData()
    })
  }

  handleRangeEnd = () => {
    this.setState({ isInteracting: false }, () => {
      this.sendData()
    })
  }

  handleDeleteClick = () => {
    this.props.onDelete()
  }

  render() {
    const { showMe, ageRange, distanceIn } = this.state
    // const { showMe, distanceIn, ageRange, maxDistance } = this.state

    return (
      <Div height="100%" display="flex" flexDirection="column">
        <SettingsSection hasBorder title="Show Me">
          <RadioList
            name="showMe"
            value={showMe}
            onChange={this.handleChange}
            items={[
              { value: 'male', label: 'Men' },
              { value: 'female', label: 'Women' }
            ]}
          />
        </SettingsSection>
        <SettingsSection
          hasBorder
          title="Age Range"
          secondaryText={`${ageRange[0]} - ${ageRange[1]}${
            ageRange[1] === 55 ? '+' : ''
          }`}
        >
          <Range
            name="ageRange"
            min={18}
            max={55}
            value={ageRange}
            onBeforeChange={this.handleRangeStart}
            onAfterChange={this.handleRangeEnd}
            onChange={this.handleChange}
          />
        </SettingsSection>
        {/* <SettingsSection
          hasBorder
          title="Max Distance"
          secondaryText={this.getDistanceString(maxDistance)}
        >
          <Range
            name="maxDistance"
            min={0}
            max={100}
            value={maxDistance}
            onBeforeChange={this.handleRangeStart}
            onAfterChange={this.handleRangeEnd}
            onChange={this.handleChange}
          />
        </SettingsSection> */}
        <SettingsSection hasBorder title="Distance in">
          <RadioList
            name="distanceIn"
            value={distanceIn}
            onChange={this.handleChange}
            items={[
              { value: 'miles', label: 'Miles' },
              { value: 'km', label: 'Kilometer' }
            ]}
          />
        </SettingsSection>
        <SettingsSection fill>
          <Link
            css={{ marginBottom: 5 }}
            external
            href="http://bit.ly/crush_terms"
          >
            Terms of Service
          </Link>
          <Link
            css={{ marginBottom: 5 }}
            external
            href="http://bit.ly/crush_privacy"
          >
            Privacy Policy
          </Link>
          <Link css={{ marginBottom: 5 }} to="/stored-data">
            Stored Data
          </Link>
          <Div flexGrow={1} />
          <BigButton onClick={this.handleDeleteClick}>Delete Account</BigButton>
        </SettingsSection>
      </Div>
    )
  }
}

export default Settings



// WEBPACK FOOTER //
// ./src/components/settings/Settings.js